module.exports = "/_next/static/images/Frame@2x-0eaa908d07bc4388bd15ea8b4bf0988c.webp";